import React, { useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';

import { Button } from 'react-bootstrap';
import { ShouldRender } from '../../ui-core/ShouldRender';

import {
  doToggleCartModal,
  doFetchCartRequest,
  doFetchLoggedOutCartRequest,
} from '../../store/action/checkout';
import { SEGMENT_EVENTS, trackEvent } from '../../utils/Segment';
import { IMAGE_CONSTANT, LOCAL_STORAGE_CONSTANT } from '../../constants/app';
import { getPageName } from '../../utils/helpers';

import './style.css';
import { extractJSON } from '../../services/jsonUtil';

const CheckoutCart = ({ showCheckoutText = false }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { cart } = useSelector(state => state.checkout);
  const cartItems = useMemo(() => {
    if (!cart) return [];
    return cart?.attributes?.selected || [];
  }, [cart]);
  const page = useMemo(() => {
    return getPageName(location.pathname);
  }, [location.pathname]);
  const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);

  const itemsCount = useMemo(() => {
    return cartItems?.length || 0;
  }, [cartItems]);

  useEffect(() => {
    if (cart === null) {
      dispatch(doFetchCartRequest());
      if (!user) {
        dispatch(doFetchLoggedOutCartRequest());
      }
    }
  }, []);

  const handleClick = () => {
    trackEvent(SEGMENT_EVENTS.BUTTON_CLICKED, {
      button_title: 'Cart Icon',
      page,
      section_title: 'Header Bar',
    });
    dispatch(doToggleCartModal(true));
  };

  return (
    <React.Fragment>
      <Button
        className="p-2 cart-icon d-flex flex-column justify-content-between align-items-center"
        onClick={handleClick}
        variant="light"
      >
        <img alt="cart" src={IMAGE_CONSTANT.shoppingCartIcon} />
        <ShouldRender check={itemsCount > 0}>
          <span className="items-count">{itemsCount}</span>
        </ShouldRender>
        <ShouldRender check={showCheckoutText}>
          <span>Checkout</span>
        </ShouldRender>
      </Button>
    </React.Fragment>
  );
};

CheckoutCart.propTypes = {
  showCheckoutText: PropTypes.bool,
};

export default CheckoutCart;
